// src/data/navigationData.js
const navigationData = [
  {
    title: 'Home',
    path: '/',
    hasDropdown: false
  },
  {
    title: 'About',
    path: '/about',
    hasDropdown: true,
    dropdownItems: [
      { name: 'The Firm', path: '/about/firm' },
      { name: 'Our Values', path: '/about/values' },
      { name: 'Team', path: '/about/team' },
      { name: 'Careers', path: '/about/careers' }
    ]
  },
  {
    title: 'Services',
    path: '/services',
    hasDropdown: true,
    dropdownItems: [
      { name: 'White-Collar Crime & Economic Offences', path: '/services/white-collar-crime' },
      { name: 'Arbitration', path: '/services/arbitration' },
      { name: 'Criminal Litigation', path: '/services/criminal-litigation' },
      { name: 'Family & Matrimonial Law', path: '/services/family-matrimonial' },
      { name: 'Real Estate & Property Litigation', path: '/services/real-estate-property' },
      { name: 'Consumer Disputes', path: '/services/consumer-disputes' },
      { name: 'Banking & Finance', path: '/services/banking-finance' },
      { name: 'Civil & Commercial Litigation', path: '/services/civil-commercial' },
      { name: 'Taxation Laws', path: '/services/taxation' },
      { name: 'POSH Compliance', path: '/services/posh-compliance' },
      { name: 'Labour & Employment Laws', path: '/services/labour-employment' },
      { name: 'Intellectual Property Rights', path: '/services/intellectual-property' },
      { name: 'Transactional & Contract Management', path: '/services/transactional-contract' }
    ]
  },
  {
    title: 'Blogs',
    path: '/blogs',
    hasDropdown: false
  },
  {
    title: 'Pro Bono Initiative',
    path: '/pro-bono',
    hasDropdown: false
  },
  {
    title: 'Contact Us',
    path: '/contact',
    hasDropdown: false
  },
  {
    title: 'AI Services',
    path: '/ai-services',
    hasDropdown: false
  }
];

export default navigationData;